import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

const LOAN_POINTS = [
  'Vertaile tarjouksia useilta rahoittajilta yhdellä hakemuksella',
  'Hakemus on ilmainen eikä sido sinua mihinkään',
  'Saat tarjoukset nopeasti — usein jo saman arkipäivän aikana',
];

const FACTORING_POINTS = [
  'Muuta myyntilaskut rahaksi ennen eräpäivää',
  'Ilmainen hakemus — ei sitoumuksia ennen tarjouksen hyväksymistä',
  'Rahoittajat kilpailevat tarjouksillaan puolestasi',
];

export default function MobileApplyIntro({ product }) {
  const headline =
    product === 'loan'
      ? 'Vertaile yrityslainoja vaivatta'
      : 'Laskurahoitus kasvun tueksi';
  const points = product === 'loan' ? LOAN_POINTS : FACTORING_POINTS;

  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography variant="h2" sx={{ fontSize: '1.125rem', fontWeight: 600, mb: 1.5 }}>
        {headline}
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          pl: 2.25,
          color: 'text.secondary',
          '& li': { mb: 1, pl: 0.5 },
          '& li:last-of-type': { mb: 0 },
        }}
      >
        {points.map((point) => (
          <Typography key={point} component="li" variant="body2">
            {point}
          </Typography>
        ))}
      </Box>
      <Divider sx={{ mt: 2.5 }} />
    </Box>
  );
}
